import { calculateLinearFeet } from '@/utils/savers/utils';
import { Form } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  getAllFreightCommodityIdEffect,
  getBranchesbyCustomerEffect,
  getTrailerConditionStatusEffect,
  getTrailerDetailsEffect,
  getTrailerRequestStatusEffect,
  getTrailersListEffect,
  getUnitSizesEffect,
  getUserRelationEffect,
  saveTrailerRequest,
} from '../../../../redux/Savers/SaversEffects';
import { setAppLoader } from '../../../../redux/common/CommonActions';
import { getFormattedTimeString } from '../../../../utilz';
import { DEFAULT_PAGE_NUMBER, excludedStatuses } from '../trailer-request.constants';
import CtTrailerRequest from './CtTrailerRequest';
import StoreTrailerRequest from './StoreTrailerRequest';
import SupplierTrailerRequest from './SupplierTrailerRequest';

const deliveryTimeOptions = [
  {
    value: '8 AM to 12 PM',
    label: '8 AM to 12 PM',
  },
  {
    value: '12 PM to 4 PM',
    label: '12 PM to 4 PM',
  },
];
const DEFAULT_PAGE_SIZE = 500;

export default function TrailerRequest() {
  const dispatch = useDispatch();

  const [formAddTrailerRequest] = Form.useForm();

  const currentDate = new Date();
  const [nameLabel, setNameLabel] = useState('Team Member Name');
  const [locationLabel, setLocationLabel] = useState('Team Member Location ID');
  const [addressLabel, setAddressLabel] = useState('Team Member Address');
  const [phoneLabel, setPhoneLabel] = useState('Team Member Phone #');
  const [trlHidden, setTrlHidden] = useState(false);
  const [pickupDateLabel, setPickupDateLabel] = useState('Pickup Date');
  const [pickupTimeLabel, setPickupTimeLabel] = useState('Pickup Time');
  const [selectedValue, setSelectedValue] = useState('');
  const [selectedTrailerPickValue, setSelectedTrailerPickValue] = useState('');
  const [selectedTrailerDoorValue, setSelectedTrailerDoorValue] = useState('');
  const [selectedLoadValue, setSelectedLoadValue] = useState('');
  const [partnerLocationOptions, setPartnerLocationOptions] = useState([]);
  const [trailerOptions, setTrailerOptions] = useState([]);
  const [trailerSizeOptions, setTrailerSizeOptions] = useState([]);
  const [commodityOptions, setCommodityOptions] = useState([]);
  const [relationOptions, setRelationOptions] = useState([]);
  const [requestTypeOptions] = useState([
    { label: 'Inbound', value: 'I' },
    { label: 'Outbound', value: 'O' },
    { label: 'Round', value: 'R' },
  ]);
  const [liveLoadHoursOptions] = useState([
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
  ]);
  const [liveLoadHours, setLiveLoadHours] = useState(0);
  const [trailerConditionStatusOptions, setTrailerConditionStatusOptions] = useState([]);
  const [hidden, setHidden] = useState(false);
  const [checked, setChecked] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [trailerID, setTrailerID] = useState(0);
  const [trailerName, setTrailerName] = useState('');
  const [locationID, setLocationID] = useState(0);
  const [stop1, setStop1] = useState(0);
  const [stop2, setStop2] = useState(0);
  const [stop3, setStop3] = useState(0);
  const [pickupTrailerSize, setPickupTrailerSize] = useState('');
  const [trailerConditionStatusID, setTrailerConditionStatusID] = useState('');
  const [trailerRequestDate, setTrailerRequestDate] = useState(currentDate);
  const [isLoadedPickUp, setIsLoadedPickUp] = useState(false);
  const [isEmptyPickUp, setIsEmptyPickUp] = useState(false);
  const [productType, setProductType] = useState('');
  const [productName, setProductName] = useState('');
  const [sealNumber, setSealNumber] = useState(null);
  const [estimatedWeight, setEstimatedWeight] = useState(0);
  const [estimatedDimension, setEstimatedDimension] = useState(0);
  const [deliveryproductType, setdeliveryProductType] = useState('');
  const [deliveryDate, setDeliveryDate] = useState(null);
  const [deliveryTime, setDeliveryTime] = useState('');
  const [pTimeToCheck, setPTimeToCheck] = useState('');
  const [isEmptyDelivered, setIsEmptyDelivered] = useState(false);
  const [isLoadedDelivered, setIsLoadedDelivered] = useState(false);
  const [isMultiStop, setIsMultiStop] = useState(false);
  const [trailerDoorType, setTrailerDoorType] = useState('');
  const [isLiveLoad, setIsLiveLoad] = useState(false);
  const [specialInstruction, setSpecialInstruction] = useState('');
  const [userType, setUserType] = useState('');
  const [fullName, setFullName] = useState('');
  const [branchDesc, setBranchDesc] = useState('');
  const [branchKey, setBranchKey] = useState(0);
  const [branchAddr1, setBranchAddr1] = useState('');
  const [branchBusPhone, setBranchBusPhone] = useState('');
  const [rscm, setRSCM] = useState('');
  const [scs, setSCS] = useState('');
  const [requester, setRequester] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [branchAddr2, setBranchAddr2] = useState('');
  const [branchCity, setBranchCity] = useState('');
  const [branchState, setBranchState] = useState('');
  const [branchPostal, setBranchPostal] = useState('');
  const [branchCustRef, setBranchCustRef] = useState('');
  const [newErrorAlert, setNewErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [loadTrailer, setLoadTrailer] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const [warning, setWarning] = useState('');
  const [districtManager, setDistrictManager] = useState('');

  const onConfirmFunc = () => {
    setNewErrorAlert(false);
    setErrorMessage('');
  };

  const companyId = useSelector((state) => state.auth.selectedCompany.companyId, shallowEqual);
  const location = useLocation();
  const vendorId = location.state?.vendorId ?? null;

  useEffect(() => {
    if (companyId) {
      getPartnerLocations(companyId);
      getUserRelations();
      getTrailerSizes();
      getTrailerCommodities();
      getTrailerConditionStatus();
      getTrailerRequestStatus();
    }
  }, [companyId]);

  useEffect(() => {
    if (relationOptions && relationOptions.length > 0) {
      dispatch(setAppLoader(true));
      if (
        relationOptions[0].userType !== 'CT' &&
        relationOptions[0].userType !== 'Store' &&
        relationOptions[0].userType !== 'STORE'
      ) {
        setNameLabel('Supplier Name');
        setLocationLabel('Supplier Location ID');
        setAddressLabel('Supplier Address');
        setPhoneLabel('Supplier Phone #');
        setTrlHidden(true);
      }
      setFullName(relationOptions[0].fullName);
      setBranchKey(relationOptions[0].branchKey);
      setLocationID(relationOptions[0].branchKey);
      setBranchDesc(relationOptions[0].branchDesc);
      setBranchAddr1(relationOptions[0].branchAddr1);
      setBranchBusPhone(relationOptions[0].branchBusPhone);
      setRSCM(relationOptions[0].rscm);
      setSCS(relationOptions[0].scs);
      setBranchAddr2(relationOptions[0].branchAddr2);
      setBranchCity(relationOptions[0].branchCity);
      setBranchState(relationOptions[0].stateName);
      setBranchPostal(relationOptions[0].branchZip);
      setBranchCustRef(relationOptions[0].branchCustRef);

      formAddTrailerRequest.setFieldsValue({
        PartnerLocation: relationOptions[0]?.branchDesc,
        txtfullname: relationOptions[0]?.fullName,
        txtscs: relationOptions[0]?.scs,
        districtManager: relationOptions[0]?.districtManager,
        txtrscm: relationOptions[0]?.rscm,
        txtaddr1: relationOptions[0]?.branchAddr1,
        txtphone: relationOptions[0]?.branchBusPhone,
        txtDelAddr: relationOptions[0]?.branchAddr1,
        txtDelLocation: relationOptions[0]?.branchKey,
        pickupLocation: relationOptions[0]?.branchDesc,
        deliveryLocation: relationOptions[0]?.branchDesc,
      });
      if (relationOptions[0].userType === 'Supplier') {
        formAddTrailerRequest.setFieldsValue({
          txtAddr2: relationOptions[0]?.branchAddr2,
          txtCity: relationOptions[0]?.branchCity,
          txtState: relationOptions[0]?.stateName,
          txtPostal: relationOptions[0]?.branchZip,
        });
      }
      dispatch(setAppLoader(false));
    }
  }, [relationOptions]);

  useEffect(() => {
    if (userType === 'Supplier') {
      setChecked(!checked);
      setIsEmptyPickUp(false);
      setIsLoadedPickUp(true);
      setSelectedTrailerPickValue('Loaded');
      setPickupDateLabel('Date Trailer Loaded');
      setPickupTimeLabel('Time Trailer Loaded');
      getTrailerList(branchKey, 'LOD');
    }
  }, [userType]);

  const getPartnerLocations = async (companyId) => {
    dispatch(setAppLoader(true));
    if (companyId) {
      try {
        // TODO: useGetShipmentVendorBranch hook
        const { data } = await getBranchesbyCustomerEffect(companyId);
        const options = data.map((row) => ({
          label: row.branchDesc,
          value: row.branchKey,
        }));
        setPartnerLocationOptions(options);
      } catch (error) {
        console.error(error);
        setPartnerLocationOptions([]);
      }
    }
  };

  const SaveTrailerRequest = async () => {
    const requestData = [];
    try {
      dispatch(setAppLoader(true));
      requestData.push({
        trailerRequestID: 0,
        locationID: locationID,
        trailerID: trailerID,
        pickupTrailerSize: pickupTrailerSize.toString(),
        trailerConditionStatusID: trailerConditionStatusID,
        trailerRequestDate: trailerRequestDate,
        trafficCoordinatorID: 0,
        trailerRequestStautsID: '',
        isLoadedPickUp: isLoadedPickUp,
        isEmptyPickUp: isEmptyPickUp,
        productType: productType.toString(),
        estimatedWeight: estimatedWeight,
        estimatedDimension: estimatedDimension,
        deliveryDate: deliveryDate,
        deliveryTimeFrame: deliveryTime,
        isEmptyDelivered: isEmptyDelivered,
        deliveryProductType: deliveryproductType.toString(),
        isLoadedDelivered: isLoadedDelivered,
        isMultiStop: isMultiStop,
        trailerDoorType: trailerDoorType,
        isLiveLoad: isLiveLoad,
        specialInstructionTrailerSize: '',
        specialInstruction: specialInstruction,
        stopOne: stop1,
        stopTwo: stop2,
        stopThree: stop3,
        liveLoadHours: liveLoadHours,
        commodity: productName,
        sealNumber: sealNumber,
        requesterName: requester,
        requesterPhone: phoneNumber,
        supplierNumber: userType === 'Supplier' ? branchCustRef : '',
      });

      const { data } = await saveTrailerRequest(requestData);
      if (data === 1) {
        setHidden(false);
        setAlertMessage('Trailer request data saved.');
        setAlertOpen(true);
        formAddTrailerRequest.resetFields();

        window.location.href = '/savers';
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setAppLoader(false));
    }
  };

  const handleAlertOk = () => {
    setAlertOpen(false);
    window.location.href = '/savers';
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const getTrailerList = async (branchKey, statuscode) => {
    try {
      setLoadTrailer(true);
      const params = {};
      if (branchKey !== '' && branchKey !== undefined && branchKey !== '0') {
        params.branchKey = branchKey;
      }
      if (statuscode !== '' && statuscode !== undefined) {
        params.status = statuscode;
      }
      if (userType === 'Supplier') {
        params.vendorId = vendorId;
      }
      const { data } = await getTrailersListEffect({
        PageSize: DEFAULT_PAGE_SIZE,
        PageNumber: DEFAULT_PAGE_NUMBER,
        ...params,
      });

      const options = data
        .filter((row) => !excludedStatuses.includes(row.trailerStatusID))
        .map((row) => ({
          label: row.trailerNumber,
          value: row.trailerID,
        }));
      setTrailerOptions(options);
    } catch (error) {
      console.error(error);
      setTrailerOptions([]);
    } finally {
      setLoadTrailer(false);
    }
  };

  const getTrailerSizes = async () => {
    try {
      const { data } = await getUnitSizesEffect();

      const options = data.map((row) => ({
        label: row.size,
        value: row.id,
      }));
      setTrailerSizeOptions(options);
    } catch (error) {
      console.error(error);
      setTrailerSizeOptions([]);
    }
  };

  const getUserRelations = async () => {
    dispatch(setAppLoader(true));
    try {
      const { data } = await getUserRelationEffect();

      setRelationOptions(data);
      if (data.length > 0) {
        setUserType(data[0].userType);
        setBranchKey(data[0].branchKey);
        setDistrictManager(data[0].districtManager);
      } else {
        getTrailerList();
        setUserType('');
        setFullName('');
        setBranchKey(0);
        setLocationID(0);
        setBranchDesc('');
        setBranchAddr1('');
        setBranchBusPhone('');
        setRSCM('');
        setSCS('');
        setNameLabel('Supplier Name');
        setLocationLabel('Supplier Location ID');
        setAddressLabel('Supplier Address');
        setPhoneLabel('Supplier Phone #');
        setTrlHidden(true);
      }
    } catch (error) {
      console.error(error);
      setUserType('');
      setFullName('');
      setBranchKey(0);
      setLocationID(0);
      setBranchDesc('');
      setBranchAddr1('');
      setBranchBusPhone('');
      setRSCM('');
      setSCS('');
    }
  };

  const getTrailerCommodities = async () => {
    try {
      const { data } = await getAllFreightCommodityIdEffect();

      const options = data.map((row) => ({
        label: row.freightCommodity,
        value: row.freightCommodityID,
      }));
      setCommodityOptions(options);
    } catch (error) {
      console.error(error);
      setCommodityOptions([]);
    }
  };

  const getTrailerConditionStatus = async () => {
    try {
      const { data } = await getTrailerConditionStatusEffect();

      const options = data.map((row) => ({
        label: row.codeDesc,
        value: row.codeId,
      }));
      setTrailerConditionStatusOptions(options);
    } catch (error) {
      console.error(error);
      setTrailerConditionStatusOptions([]);
    }
  };

  const getTrailerRequestStatus = async () => {
    try {
      await getTrailerRequestStatusEffect();
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setAppLoader(false));
    }
  };

  const getTrailerDetailsData = async (trailerID) => {
    try {
      const { data } = await getTrailerDetailsEffect(trailerID);
      if (data.length > 0) {
        setTrailerConditionStatusID(data[0].trailerStatusID);
        setPickupTrailerSize(data[0].unitSizeID);
        formAddTrailerRequest.setFieldsValue({
          ConditionStatus: data[0].trailerStatusID,
        });
        formAddTrailerRequest.setFieldsValue({
          trailerSize: data[0].unitSizeID,
        });
      }
    } catch (error) {
      console.error(error);
      setTrailerConditionStatusID('');
      setPickupTrailerSize('');
    }
  };

  const selectStop1 = (e) => {
    setStop1(e.value);
  };

  const selectStop2 = (e) => {
    setStop2(e.value);
  };

  const selectStop3 = (e) => {
    setStop3(e.value);
  };

  const selectLocationID = (e) => {
    setLocationID(e.value);
    setBranchKey(e.value);
    setBranchDesc(e.label);
  };

  const selectTrailerConditionStatus = (e) => {
    setTrailerConditionStatusID(e.value);
  };

  const selectTrailerName = (e) => {
    if (e) {
      setTrailerID(e.value);
      setTrailerName(e.label);
      getTrailerDetailsData(e.value);
    } else {
      setTrailerID(0);
      setTrailerName('');
    }
  };

  const selectTrailerSize = (e) => {
    setPickupTrailerSize(e.value);
  };

  const selectRequestDate = (e) => {
    let trailerreqdate = moment(e).format().substring(0, 10);
    if (pTimeToCheck) {
      const newDate = `${trailerreqdate} ${pTimeToCheck}`;
      const date = new Date(newDate);
      trailerreqdate = getFormattedTimeString(date);
    }
    ValidatePickupDate(trailerreqdate);
    setTrailerRequestDate(trailerreqdate);
    ValidateDateRange(trailerreqdate, deliveryDate);
  };

  const selectRequestTime = (e) => {
    const trailerreqtime = moment(e).format('HH:mm:ss');
    setPTimeToCheck(moment(e).format('HH:mm'));
    const newDate = `${trailerRequestDate.substring(0, 10)} ${trailerreqtime}`;
    const date = new Date(newDate);
    const formattedDate = getFormattedTimeString(date);
    setTrailerRequestDate(formattedDate);
  };

  const setRequesterName = (e) => {
    setRequester(e.currentTarget.value);
  };

  const setSupplierPhone = (e) => {
    setPhoneNumber(e.currentTarget.value);
  };

  const setProdWeight = (e) => {
    const value = e.currentTarget.value;
    setEstimatedWeight(value);
    setEstimatedDimension(calculateLinearFeet(value, productType));
  };

  const setProdDimension = (e) => {
    setEstimatedDimension(e.currentTarget.value);
  };
  const selectCommodity = (e) => {
    setProductType(e.value);
    setEstimatedDimension(calculateLinearFeet(estimatedWeight, e.value));
  };

  const selectProduct = (e) => {
    setProductName(e.currentTarget.value);
  };
  const selectSealNumber = (e) => {
    setSealNumber(e.currentTarget.value);
  };

  const setLiveLoadUnloadHour = (e) => {
    if (e) setLiveLoadHours(e.value);
    else {
      setLiveLoadHours(0);
    }
  };

  const selectdeliveryCommodity = (e) => {
    setdeliveryProductType(e.value);
  };

  const selectDeliveryDate = (e) => {
    const trailerdeldate = moment(e).format().substring(0, 10);
    ValidateDeliverydate(trailerdeldate);
    setDeliveryDate(trailerdeldate);
    ValidateDateRange(trailerRequestDate, trailerdeldate);
  };

  const selectDeliveryTime = (e) => {
    setDeliveryTime(e.value);
  };

  const selectDelivered = (e) => {
    if (e.currentTarget.id === 'Empty') {
      setIsEmptyDelivered(true);
      setIsLoadedDelivered(false);
      setSelectedValue('Empty');
    } else if (e.currentTarget.id === 'Loaded') {
      setIsEmptyDelivered(false);
      setIsLoadedDelivered(true);
      setSelectedValue('Loaded');
    } else if (e.currentTarget.id === 'None') {
      setIsEmptyDelivered(false);
      setIsLoadedDelivered(false);
      setSelectedValue('None');
    }
  };

  const CloseModal = () => {
    setHidden(!hidden);
  };

  const OpenRequestPopup = () => {
    if (
      ValidateLoaded() === true &&
      ValidateTrailer() === true &&
      ValidatePickUpdate() === true &&
      ValidateCommodity() === true &&
      ValidateWeight() === true &&
      ValidateDeliveryTimeRange() &&
      ValidateDelCommodity() === true &&
      ValidateStop() === true
    ) {
      if (ValidateDateRangeCheck(trailerRequestDate, deliveryDate)) {
        setHidden(true);
      }
    }
  };

  const handleChangeLoaded = (e) => {
    dispatch(setAppLoader(true));
    setChecked(!checked);

    if (e.currentTarget.id === 'pickEmpty') {
      setIsEmptyPickUp(true);
      setIsLoadedPickUp(false);
      setSelectedTrailerPickValue('Empty');
      setPickupDateLabel('Date Trailer Emptied');
      setPickupTimeLabel('Time Trailer Emptied');
      if (userType !== 'CT') {
        getTrailerList(branchKey, 'EMT');
      } else {
        getTrailerList('', 'EMT');
      }
    } else if (e.currentTarget.id === 'pickLoaded') {
      setIsEmptyPickUp(false);
      setIsLoadedPickUp(true);
      setSelectedTrailerPickValue('Loaded');
      setPickupDateLabel('Date Trailer Loaded');
      setPickupTimeLabel('Time Trailer Loaded');
      if (userType !== 'CT') {
        getTrailerList(branchKey, 'LOD');
      } else {
        getTrailerList('', 'LOD');
      }
    } else if (e.currentTarget.id === 'pickNone') {
      setIsEmptyPickUp(false);
      setIsLoadedPickUp(false);
      setSelectedTrailerPickValue('None');
      setPickupDateLabel('Pickup Date');
      setPickupTimeLabel('Pickup Time');
      setTrailerOptions([]);
    }

    dispatch(setAppLoader(false));
  };

  const handleChangeEmpty = (e) => {
    dispatch(setAppLoader(true));
    setChecked(false);

    if (e.currentTarget.id === 'pickEmpty') {
      setIsEmptyPickUp(true);
      setIsLoadedPickUp(false);
      setSelectedTrailerPickValue('Empty');
      setPickupDateLabel('Date Trailer Emptied');
      setPickupTimeLabel('Time Trailer Emptied');
      if (userType !== 'CT') {
        if (userType.toLowerCase() === 'store') {
          getTrailerList();
        } else {
          getTrailerList(branchKey, 'EMT');
        }
      } else {
        getTrailerList('', 'EMT');
      }
    } else if (e.currentTarget.id === 'pickLoaded') {
      setIsEmptyPickUp(false);
      setIsLoadedPickUp(true);
      setSelectedTrailerPickValue('Loaded');
      setPickupDateLabel('Date Trailer Loaded');
      setPickupTimeLabel('Time Trailer Loaded');
      if (userType !== 'CT') {
        getTrailerList(branchKey, 'LOD');
      } else {
        getTrailerList('', 'LOD');
      }
    } else if (e.currentTarget.id === 'pickNone') {
      setIsEmptyPickUp(false);
      setIsLoadedPickUp(false);
      setSelectedTrailerPickValue('None');
      setPickupDateLabel('Pickup Date');
      setPickupTimeLabel('Pickup Time');
      setTrailerOptions([]);
    }
    dispatch(setAppLoader(false));
  };

  const handleChangeMultiStopY = (e) => {
    setChecked1(!checked1);
    if (e.currentTarget.checked) {
      setIsMultiStop(true);
    } else {
      setIsMultiStop(false);
    }
  };

  const handleChangeMultiStopN = () => {
    setIsMultiStop(false);
    setChecked1(false);
  };

  const selectDoorType = (e) => {
    setTrailerDoorType(e.currentTarget.value);
    if (e.currentTarget.id === 'Swingdoor') {
      setSelectedTrailerDoorValue(e.currentTarget.id);
    } else if (e.currentTarget.id === 'RollUpdoor') {
      setSelectedTrailerDoorValue(e.currentTarget.id);
    } else if (e.currentTarget.id === 'Slidingdoor') {
      setSelectedTrailerDoorValue(e.currentTarget.id);
    } else if (e.currentTarget.id === 'Foldingdoor') {
      setSelectedTrailerDoorValue(e.currentTarget.id);
    } else if (e.currentTarget.id === 'Hingeddoor') {
      setSelectedTrailerDoorValue(e.currentTarget.id);
    }
  };

  const selectLiveLoad = (e) => {
    if (e.currentTarget.value === 'Yes') {
      setIsLiveLoad(true);
      setSelectedLoadValue('Load');
    } else if (e.currentTarget.value === 'No') {
      setIsLiveLoad(false);
      setSelectedLoadValue('UnLoad');
      setLiveLoadHours(0);
      formAddTrailerRequest.setFieldValue('LiveLoadHours', '');
    }
  };

  const selectSpecialInstruction = (e) => {
    setSpecialInstruction(e.currentTarget.value);
  };

  const ValidateDateRange = (reqDate, delDate) => {
    const isInvalidDate = (date) => !date || date === 'Invalid da';

    if (isInvalidDate(reqDate) || isInvalidDate(delDate)) return;

    if (reqDate > delDate) {
      setNewErrorAlert(true);
      setErrorMessage('Trailer pickup date cannot be greater than delivery date');
    }
  };

  const ValidateDateRangeCheck = (reqDate, delDate) => {
    // Helper function to check for invalid or empty dates
    const isInvalidDate = (date) => !date || date === 'Invalid da';

    // Return true if either date is invalid or empty
    if (isInvalidDate(reqDate) || isInvalidDate(delDate)) return true;

    // Check if the request date is greater than the delivery date
    if (reqDate > delDate) {
      setNewErrorAlert(true);
      setErrorMessage('Trailer pickup date cannot be greater than delivery date');
      return false;
    }

    return true;
  };

  const ValidateLoaded = () => {
    if (
      (selectedTrailerPickValue !== '' &&
        selectedTrailerPickValue !== 'None' &&
        selectedTrailerPickValue !== undefined) ||
      (selectedValue !== '' && selectedValue !== 'None' && selectedValue !== undefined)
    ) {
      return true;
    }

    if (!selectedTrailerPickValue && !selectedValue) {
      setNewErrorAlert(true);
      setErrorMessage('Please choose Pickup-Delivery option');
      return false;
    }

    if (specialInstruction !== '' && specialInstruction !== undefined) {
      return true;
    }

    setNewErrorAlert(true);
    setErrorMessage('Please provide instruction.');
    return false;
  };

  const ValidateTrailer = () => {
    if (userType === 'Store') {
      if (selectedTrailerPickValue === 'Empty' || selectedTrailerPickValue === 'Loaded') {
        if (trailerID !== 0) {
          return true;
        }

        setNewErrorAlert(true);
        setErrorMessage('Please select Trailer');
        return false;
      }
      return true;
    }
    if (userType === 'Supplier') {
      if (selectedTrailerPickValue === 'Loaded') {
        if (!trailerID) {
          setNewErrorAlert(true);
          setErrorMessage('Please select Trailer');
          return false;
        }
      } else {
        return true;
      }
    }

    return true;
  };

  const ValidateCommodity = () => {
    if (selectedTrailerPickValue !== 'Loaded') {
      return true;
    }

    if (selectedTrailerPickValue === 'Loaded') {
      if (productType !== '' && productType !== undefined) {
        if (document.getElementById('errorCommodity') !== null) {
          // You can add any logic here if needed
        }
        return true;
      }

      setNewErrorAlert(true);
      setErrorMessage('Select commodity');
      return false;
    }
  };

  const ValidateWeight = () => {
    if (userType === 'Supplier' || userType === 'Store') {
      return true;
    }

    if (selectedTrailerPickValue !== 'Loaded') {
      if (document.getElementById('errorWeight') !== null) {
        // You can add logic here if needed
      }
      return true;
    }

    if (selectedTrailerPickValue === 'Loaded') {
      if (estimatedWeight !== '0' && estimatedWeight !== 0) {
        if (document.getElementById('errorWeight') !== null) {
          // You can add logic here if needed
        }
        return true;
      }

      setNewErrorAlert(true);
      setErrorMessage('Weight required');
      return false;
    }
  };

  const ValidateDeliverydate = (deliveryDate) => {
    if (selectedValue === 'Loaded' || selectedValue === 'Empty') {
      const minDate = moment().add(3, 'days').startOf('day');
      const selectedDate = moment(deliveryDate, 'YYYY-MM-DD');

      if (selectedDate.isValid() && selectedDate.isSameOrAfter(minDate)) {
        return true;
      }
      setWarningModal(true);
      setWarning(
        'The requested date is not within 72 hours.  The traffic team will make every effort to meet your requested timeline',
      );
      return true;
    }
  };

  const ValidatePickupDate = (pickupDate) => {
    if (selectedTrailerPickValue === 'Loaded' || selectedTrailerPickValue === 'Empty') {
      const minDate = moment().add(3, 'days').startOf('day');
      const selectedDate = moment(pickupDate, 'YYYY-MM-DD');

      if (selectedDate.isValid() && selectedDate.isSameOrAfter(minDate)) {
        return true;
      }
      setWarningModal(true);
      setWarning(
        'The requested pickup date is not within 72 hours. The traffic team will make every effort to meet your requested timeline',
      );
      return true;
    }
  };

  const ValidateDeliveryTimeRange = () => {
    if (selectedValue === 'Loaded' || selectedValue === 'Empty') {
      if (deliveryTime) {
        return true;
      }
      setNewErrorAlert(true);
      setErrorMessage('Please select delivery time between 8 AM and 4 PM');
      return false;
    }
    return true;
  };

  const ValidatePickUpdate = () => {
    if (trailerRequestDate || selectedTrailerPickValue === 'None') {
      return true;
    }
    setNewErrorAlert(true);
    setErrorMessage('Pickup date required');
    return false;
  };

  const ValidateStop = () => {
    if (isMultiStop === false) {
      return true;
    }
    if (stop1 !== 0 && stop1 !== '0') {
      return true;
    }
    setNewErrorAlert(true);
    setErrorMessage('Select stop1 location');
    return false;
  };

  const ValidateDelCommodity = () => {
    if (selectedValue !== 'Loaded') {
      return true;
    }

    if (selectedValue === 'Loaded') {
      if (deliveryproductType !== '' && deliveryproductType !== undefined) {
        return true;
      }

      setNewErrorAlert(true);
      setErrorMessage('Select delivery commodity');
      return false;
    }
  };

  const disabledTime = () => {
    return {
      disabledHours: () => {
        const hours = [];

        for (let i = 0; i < 24; i++) {
          if (i < 8 || i > 15) {
            hours.push(i);
          }
        }
        return hours;
      },
      disabledMinutes: () => {
        return [];
      },
      disabledSeconds: () => {
        return [];
      },
    };
  };

  const trailerSize = formAddTrailerRequest.getFieldValue('trailerSize') || 0;
  const trailerValue = trailerSize && trailerSizeOptions?.filter((val) => val.value === trailerSize)[0]?.label;
  const percentage =
    trailerValue > 0 && estimatedDimension >= 0 ? Math.min((estimatedDimension / trailerValue) * 100, 100) : 0;

  const getProgressBarColor = (percentage) => {
    if (percentage <= 90) return 'red';
    if (percentage <= 95) return 'yellow';
    return 'green';
  };

  const progressBarColor = getProgressBarColor(percentage);

  const commonProps = {
    userType,
    getTrailerList,
    branchKey,
    trailerOptions,
    fullName,
    locationID,
    branchAddr1,
    nameLabel,
    formAddTrailerRequest,
    trlHidden,
    branchCustRef,
    selectedTrailerPickValue,
    trailerConditionStatusID,
    selectLocationID,
    partnerLocationOptions,
    commodityOptions,
    trailerSizeOptions,
    trailerConditionStatusOptions,
    branchDesc,
    disabledTime,
    selectSpecialInstruction,
    selectLiveLoad,
    handleChangeMultiStopN,
    selectDoorType,
    handleChangeMultiStopY,
    handleChangeEmpty,
    handleChangeLoaded,
    OpenRequestPopup,
    CloseModal,
    selectDelivered,
    selectDeliveryTime,
    selectDeliveryDate,
    selectdeliveryCommodity,
    setLiveLoadUnloadHour,
    selectProduct,
    selectSealNumber,
    selectCommodity,
    setSupplierPhone,
    setProdWeight,
    setProdDimension,
    setRequesterName,
    selectRequestTime,
    selectRequestDate,
    selectTrailerSize,
    selectTrailerName,
    selectTrailerConditionStatus,
    selectStop3,
    selectStop2,
    selectStop1,
    handleAlertClose,
    handleAlertOk,
    SaveTrailerRequest,
    locationLabel,
    addressLabel,
    phoneLabel,
    pickupTimeLabel,
    pickupDateLabel,
    selectedTrailerDoorValue,
    selectedLoadValue,
    requestTypeOptions,
    liveLoadHoursOptions,
    trailerName,
    deliveryTime,
    branchBusPhone,
    rscm,
    scs,
    branchAddr2,
    branchCity,
    branchState,
    branchPostal,
    newErrorAlert,
    errorMessage,
    alertOpen,
    alertMessage,
    onConfirmFunc,
    isLoadedPickUp,
    selectedValue,
    checked1,
    isLoadedDelivered,
    hidden,
    deliveryDate,
    estimatedDimension,
    isLiveLoad,
    requester,
    stop1,
    stop2,
    stop3,
    setHidden,
    deliveryTimeOptions,
    loadTrailer,
    warningModal,
    setWarningModal,
    warning,
    districtManager,
    isEmptyPickUp,
    progressBarColor,
    percentage,
    estimatedWeight,
  };

  if (!userType) return null;

  if (userType === 'Store') {
    return <StoreTrailerRequest {...commonProps} />;
  }

  if (userType === 'Supplier') {
    return <SupplierTrailerRequest {...commonProps} />;
  }

  return <CtTrailerRequest {...commonProps} />;
}
